import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

const apiPrefix = '/notifications/v1/';

const routes = {
    getNotifications: (page = 0, size = 10) => apiPrefix + `notifications?page=${page}&size=${size}`,
    notificationUnreadCount: () => apiPrefix + `notification-unread-count`,
    notifications: () => apiPrefix + `notifications`,
    whatsAppOptIn: () => apiPrefix + `opt-in-whatsapp-number`,
    whatsAppOptOut: () => apiPrefix + `opt-out-whatsapp-number`,
};

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor(private http: HttpClient) {
    }

    getNotifications(statusFilter: string, page?: number, size?: number) {

        const $notifications: Observable<any> = this.http
            .get(routes.getNotifications(page, size), {
                params: {
                    statusFilter
                }
            }).pipe(
                map((notifications: any) => {
                    return notifications as any;
                })
            );
        return $notifications;

    }

    getNotificationUnreadCount() {
        const $counts: Observable<any> = this.http
            .get(routes.notificationUnreadCount(), {
                responseType: 'text'
            }).pipe(
                map((count: any) => {
                    return count as any;
                })
            );
        return $counts;
    }

    markSelectedNotificationAsRead(notifications: any, markAllAsRead: any) {
        const $notification: Observable<any> = this.http
            .put(routes.notifications(), notifications, {
                params: {
                    markAllAsRead
                }
            })
            .pipe(map((notificationRes) => {
                return notificationRes as any;
            }));
        return $notification;
    }

    whatsAppOptIn(phonenumber: string, stdcode: string) {
        const $optIn: Observable<any> = this.http
            .get(routes.whatsAppOptIn(), {
                params: {
                    phonenumber,
                    stdcode
                }, responseType: 'text'
            }).pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $optIn;
    }

    whatsAppOptOut(phonenumber: string, stdcode: string) {
        const $optOut: Observable<any> = this.http
            .get(routes.whatsAppOptOut(), {
                params: {
                    phonenumber,
                    stdcode
                }, responseType: 'text'
            }).pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $optOut;
    }
}
